import { VueCharts, mixins } from 'vue-chartjs';
import * as _ from 'lodash';

const { reactiveProp } = mixins;

const templateChartData = {
  labels: [],
  datasets: [
    {
      label: 'Responses',
      borderColor: '#17375E',
      backgroundColor: '#17375E',
      yAxisID: 'responsesAxis',
      type: 'line',
      data: [],
      fill: false,
      datalabels: {
        formatter() {
          return '';
        }
      }
    },
    {
      label: 'Average Score',
      borderColor: '#0078D7',
      backgroundColor: '#0078D7',
      data: [],
      fill: false,
      datalabels: {
        formatter() {
          return '';
        }
      }
    }
    
  ]
};

export default {
  extends: VueCharts.Bar,
  mixins: [reactiveProp],
  props: [
    'chartData',
    'elementName'
  ],
  watch: {
    chartData: {
      handler(newData) {
        if (newData) this.draw();
      }
    }
  },
  mounted() {
    this.addPlugin({
      beforeDraw(chartInstance) {
        const ctx = chartInstance.chart.ctx; // eslint-disable-line prefer-destructuring
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, chartInstance.chart.width, chartInstance.chart.height);
      }
    });

    if (this.chartData) this.draw();
  },
  methods: {
    draw() {
      const newChartData = _.cloneDeep(templateChartData);

      let minResponses = -1;
      let maxResponses = 0;
      // filter for type of element
      this.chartData.forEach((dataRow) => {
        newChartData.datasets[1].data.push(parseFloat(dataRow.averageScore).toFixed(2));
        newChartData.datasets[0].data.push(dataRow.responses);
        if (dataRow.responses < minResponses || minResponses == -1) minResponses = dataRow.responses;
        if (dataRow.responses > maxResponses) maxResponses = dataRow.responses;
        newChartData.labels.push(dataRow.dimension);
      });

      // console.log('newChartData');
      // console.log(newChartData);

      this.renderChart(newChartData, {
        responsive: false,
        maintainAspectRatio: true,
        layout: {
          padding: {
            right: 100
          }
        },
        elements: {
          line: {
            tension: 0
          }
        },
        legend: {
          display: 'false'
        },
        title: {
          display: true,
          text: `${this.elementName} Scores and Responses`,
          fontColor: '#000000',
          fontFamily: 'Stag-Black',
          fontStyle: 'bold',
          fontSize: 24
        },
        scales: {
          xAxes: [
            {
              ticks: {
                display: true,
                fontStyle: 'bold',
                fontColor: '#333333',
                fontSize: 12,
                autoSkip: false
              },
              gridLines: {
                display: true,
                color: '#aaaaaa',
                lineWidth: 1,
                drawOnChartArea: true,
                borderDashOffset: -10
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                display: true,
                min: 1,
                max: 4,
                stepSize: 1
              },
              gridLines: {
                display: true,
                color: '#aaaaaa',
                lineWidth: 1,
                drawOnChartArea: true,
                borderDashOffset: -10
              }
            },
            {
              id: 'responsesAxis',
              position: 'right',
              offset: false,
              ticks: {
                display: true,
                fontStyle: 'bold',
                min: minResponses,
                max: maxResponses
              },
              gridLines: {
                drawBorder: false
              }
            }
          ]
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/graphs/ElementIndustryBar.js